import type { PossibleTypesMap } from "@apollo/client"

export const customFormsPossibleTypes: PossibleTypesMap = {
  CustomFormsResponseAnswerInterface: [
    "CustomFormsResponseFileAnswer",
    "CustomFormsResponseStringAnswer",
    "CustomFormsResponseMultiStringAnswer",
  ],
  CustomFormsSchemaFieldInterface: ["CustomFormsSchemaFieldGroup", "CustomFormsSchemaInputField"],
  CustomFormsSchemaInputConfigurationUnion: ["CustomFormsSchemaInputSingleChoiceConfiguration"],
}
